import { CourseData } from '@data/course/courseData';
import { UserData } from '@ypp-portal/models/user/userData';
import React from 'react';

interface CourseApprovalBasicInfoProps {
  instructorData: UserData[];
  courseData: CourseData;
}

const CourseBasicInfoDisplay: React.FC<CourseApprovalBasicInfoProps> = ({
  instructorData,
  courseData,
}) => {
  return (
    <div className='text-xl'>
      <h1 className='inline-block'>
        {instructorData.map((x) => x.static.firstName + ' ' + x.static.lastName).join(', ')}
      </h1>
      <h1 className='font-bold inline-block ml-16'>{courseData.name}</h1>
    </div>
  );
};

export default CourseBasicInfoDisplay;
